import { mapGetters, mapState } from "vuex"

import misc_utilities from "./MiscUtilities"
import addl_string_utilities from "./AddlStringUtilities"

const utilities = {
    watch: {
        profile_id: "profile_id_changed"
    },
    mixins: [misc_utilities, addl_string_utilities],
    methods: {
        profile_id_changed () {
            if(this.autoload) this.autoload()
        },
        can () {
            if(!this.profile_id) return false
            return true
        },
        role_is_assistant (role_name) {
            if(!role_name) return false
            return role_name === "assistant"
        },
        role_is_administrator (role_name) {
            if(!role_name) return false
            return role_name === "administrator"
        },
        role_is_developer (role_name) {
            if(!role_name) return false
            return role_name === "developer"
        },
        role_is_at_least_administrator (role_name) {
            return this.role_is_administrator(role_name) || this.role_is_developer(role_name)
        },
        role_is_at_least_assistant (role_name) {
            return this.role_is_assistant(role_name) || this.role_is_administrator(role_name) || this.role_is_developer(role_name)
        },
        role_label (role) {
            if((typeof role === "string") || (role && role.name)) return this.ucwords(role.name || role)
            return role
        },
        profile_subscribed (profile) {
            if(!profile) return false
            if(this.role_is_at_least_assistant(profile.role)) return true
            return !!profile.has_access
        },
        term (term_id, terms, key_field) {
            key_field = key_field || "id"
            if(!terms) return null
            const selection = terms.filter((option) => {
                return term_id === option[key_field]
            })
            if(!selection.length) return null
            return selection[0]
        },
        term_value (term_id, terms, key_field, label_field) {
            label_field = label_field || "name"
            const term = this.term(term_id, terms, key_field)
            return term ? term[label_field] : ""
        },
        asset_image_url (path) {
            return this.setting("application_images_url") + path
        }
    },
    computed: {
        ...mapGetters({
            entity_records: "entity_records",
            entity_record: "entity_record"
        }),
        ...mapState(["profile_id"]),
        roles () {
            return this.entity_records("role")
        },
        profile () {
            return this.entity_record("user", this.profile_id) || {}
        },
        is_at_least_assistant () {
            return this.is_assistant || this.is_administrator || this.is_developer
        },
        is_assistant () {
            if(!this.profile) return false
            return this.role_is_assistant(this.profile.role)
        },
        is_at_least_administrator () {
            return this.is_administrator || this.is_developer
        },
        is_administrator () {
            if(!this.profile) return false
            return this.role_is_administrator(this.profile.role)
        },
        is_developer () {
            if(!this.profile) return false
            return this.role_is_developer(this.profile.role)
        },
        subscribed () {
            return this.profile_subscribed(this.profile)
        },
        tight_fit () {
            return this.$mq.match(/^(xs|sm)$/i)
        },
        profile_country_code () {
            if(!this.profile) return null
            return this.profile.country_code
        }
    }
}

export default utilities
